// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cb25e647","453":"f6a3dd11","455":"ee4e5ac8"}[chunkId] + ".chunk.js";
};